import Moment from 'moment'

export default class Clock
{
    constructor()
    {
        this.$paris = document.querySelector('.jsHours--paris')
        this.$shanghai = document.querySelector('.jsHours--shanghai')
        setInterval(() => {
            this.setTime()
        }, 1000);
        this.setTime()
    }

    setTime()
    {
        this.$paris.innerHTML = Moment().format('HH:mm')
        this.$shanghai.innerHTML = Moment().add(7,'hour').format('HH:mm')
    }
}


// WEBPACK FOOTER //
// ./resources/js/ui/Clock.js